import React, { Suspense, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Switch, Redirect, withRouter, useHistory } from 'react-router-dom';
import errorCatcher from 'shared/components/error-catcher';
import OfflineDetection from 'shared/components/offline';
import 'antd/dist/antd.css';
import { routes } from './routes';
import { Loader } from 'shared/components/spinner';
import ReactGA from 'react-ga';
import { useUser } from 'shared/hooks/user';
import { userSlice } from 'shared/store/user';
import { PrivateRoute } from 'shared/components/auth-route';
import { useStore } from 'react-redux';
import { AppLayout } from 'shared/components/app-layout';
import { compose } from 'recompose';
import { PATHS } from './paths';
import { firebaseApp } from 'shared/firebase';

export const { update: updateUser } = userSlice.actions;

const Main = () => {
  const history = useHistory();
  const store = useStore();
  const { user, loading } = useUser();

  useEffect(() => {
    store.dispatch(updateUser({ data: user, loading }));
  }, [store, user, loading]);

  useEffect(() => {
    ReactGA.pageview(history.location.pathname + history.location.search);
  }, [history.location.pathname, history.location.search]);

  useEffect(() => {
    return firebaseApp.auth().onIdTokenChanged(user => {
      if (user) {
        user.getIdToken().then(function(idToken) {
          localStorage.setItem('cofe-district:id_token', `${idToken}`);
        });
      }
    });
  }, []);

  if (loading) return <Loader />;

  return (
    <AppLayout>
      <OfflineDetection />
      <Suspense fallback={<Loader />}>
        <Switch>
          {routes.map(route => (
            <PrivateRoute
              key={route.path}
              path={route.path}
              component={route.component}
              permissions={route.permissions}
            />
          ))}
          <Redirect to={PATHS.ORDERS.LIST} />
        </Switch>
      </Suspense>
    </AppLayout>
  );
};

Main.propTypes = {
  history: PropTypes.object.isRequired,
};

export default compose(errorCatcher, withRouter)(Main);
